<div style="overflow:hidden;height:100%; width:100%">
  <iframe [src]="login_url" style="border: 0px none;height:100%; width:100%"></iframe>
</div>

